import { useSelector } from 'react-redux';
import { store } from 'redux/store';
import {
  selectDVCPMATrackingForecastVariable,
  setVariable as setVariableRedux,
} from 'redux/reducers/meteorologyAgroTrackingForecastDetailedViewControlPanelReducer';
import useVariableOptions from './useVariableOptions';

export default function useVariables() {
  const { variables } = useVariableOptions();
  const selectedVariable: string = useSelector(selectDVCPMATrackingForecastVariable);
  const setSelectedVariable = (newVariable: string) => (
    store.dispatch(setVariableRedux(newVariable))
  );

  return { variables, selectedVariable, setSelectedVariable };
}
